export const parseStyleValue = styleStr => {
  const value = parseFloat(styleStr);
  const units = styleStr.replaceAll(/[\d.]/gi, '');

  return [value, units]
}
